import axios from 'axios'
import ReactDOM from 'react-dom'
import { message, Spin } from 'antd'
import md5 from 'md5'
import { DefaultTimeout, EResponseCode, SIGN_SALT } from '../constants'
import { publicUrl } from '../config/host'
import { changeLogin } from '../redux/actions'

const sitBlack = ['buyer/config', 'buyer/goodsCartCount', 'buyer/simpleInfo', 'buyer/autoLottery', 'buyer/obtainAdvert', 'buyer/index1', 'buyer/changeSite']
const domain = publicUrl() // 获取当前环境url

/**
 * 退出登录，清除状态
 */
function clearLogin() {
  localStorage?.removeItem('loginToken')
  localStorage?.removeItem('userId')
  localStorage?.removeItem('userName')
  localStorage?.removeItem('telephone')

  changeLogin(false)
}

// 当前正在请求的数量
let requestCount = 0

// 显示loading
function showLoadDom() {
  if (requestCount === 0) {
    var dom = document.createElement('div')
    dom.setAttribute('id', 'loading')
    document.body.appendChild(dom)
    ReactDOM.render(<Spin tip='加载中...' size='large' />, dom)
  }
  requestCount++
}

// 隐藏loading
function hideLoadDom() {
  requestCount--
  if (requestCount === 0) {
    document.body.removeChild(document.getElementById('loading'))
  }
}

/**
 * 生成签名
 */
function genSign() {
  const random = Math.random().toString(36).slice(-8),
    timestamp = new Date().getTime()

  return {
    random,
    timestamp,
    sign: md5(`${timestamp}${random}${SIGN_SALT}`),
  }
}

/**
 * 生成form-data格式的请求体数据
 * @param {Object} params 请求参数
 * @returns {string} form-data格式的请求体数据
 */
function createFormData(params = {}) {
  // 生成一个boundary字符串
  const boundary = `----FooBar${new Date().getTime()}`
  let result = ''

  for (const i in params) {
    if (params.hasOwnProperty(i)) {
      result += `\r\n--${boundary}`
      result += `\r\nContent-Disposition: form-data; name="${i}"`
      result += '\r\n'
      result += `\r\n${params[i]}`
    }
  }
  // 如果obj不为空，则最后一行加上boundary
  if (result) {
    result += `\r\n--${boundary}`
  }

  return {
    data: result,
    boundary: boundary,
  }
}

axios.defaults.baseURL = domain
// axios.defaults.withCredentials = true; // 跨域请求时发送Cookie
axios.defaults.timeout = DefaultTimeout

// 发请求前进行拦截
axios.interceptors.request.use(config => {
  // 得到请求方式和请求体数据
  const { data: tempData, isFormData, showLoading } = config
  // requestCount为0，才创建loading, 避免重复创建
  if (showLoading) {
    showLoadDom()
  }

  if (config.method === 'get') {
    config.data = { unused: 0 } // 这个是关键点，加入这行就可以了,解决get,请求添加不上Content-Type
  }

  let logoinToken = localStorage?.getItem('loginToken')
  let noLoginiToken = localStorage.getItem('non-login-token')
  let defaultToken = 'eyJhbGciOiJIUzI1NiJ9.eyJyYW5kb20iOjY5NzA0LCJ1c2VySWQiOiIxNTcyNDI4ODY5MTg3Mjg5MDg4In0.8dMc0Fl5JpmFBgs7nFY80X-YFUERHgRc7C2l3spFVWA'

  if (!logoinToken) {
    //非登录状态下，传siteId，传认证接口返回的token
    config.headers['siteId'] = localStorage.getItem('siteId')
    config.headers['login-token'] = noLoginiToken || defaultToken
  } else {
    //登录状态，只传登录接口返回的token
    config.headers['login-token'] = logoinToken || defaultToken
  }

  config.headers['userId'] = localStorage?.getItem('userId') || '0'
  config.headers['content-type'] = 'application/json;charset=UTF-8'
  config.headers['pc'] = 'pch5'
  // store.dispatch('logined', localStorage.token)
  // 生成签名
  const { random, timestamp, sign } = genSign()

  config.headers['random'] = random
  config.headers['timestamp'] = timestamp
  config.headers['sign'] = sign

  if (isFormData) {
    const { data, boundary } = createFormData(tempData)
    config.headers['content-type'] = `multipart/form-data; boundary=${boundary}`
    config.data = data
  }
  return config
})

// 添加响应拦截器
axios.interceptors.response.use(
  (res = {}) => {
    const { data, config } = res || {}
    const { showToast, showLoading } = config || {}
    // 判断当前请求是否设置了不显示Loading
    if (showLoading) {
      hideLoadDom()
    }

    // 服务端状态校验
    if (Number(data?.code) == EResponseCode.Success || data?.success) {
      return data
    } else if (Number(data?.code) === EResponseCode.FAIL_201) {
      // 未登录
      clearLogin()
      showToast && message.error('请登录')
      return Promise.reject(res)
    } else if ([EResponseCode.NO_PARAMS, EResponseCode.TOKEN_ERROR, EResponseCode.USER_NO_EXIST, EResponseCode.UNBOUND_SITE].includes(data?.code)) {
      // -206: 缺少参数（loginToken）-207: token error；-208:当前用户不存在 ; -231未绑定站点
      return Promise.reject(res)
    } else if (EResponseCode.BingWorkNumber === Number(data?.code)) {
      // 还没绑定工号
      console.log('还没绑定工号', data)
      return Promise.reject(res)
      // Taro.reLaunch({
      //   url: '/pages/BingWorkNumber/index',
      // });
    } else if (EResponseCode.STATION_DOWN == Number(data?.code) && sitBlack.some(tempUrl => tempUrl.indexOf(config?.url) !== -1)) {
      // 首页站点下线判断
      showToast && message.error('首页站点下线')
      return Promise.reject(res)
    } else if (EResponseCode.HOLDORDER_ERROR === Number(data?.code)) {
      // 处理buyer/holdOrder接口，定制弹窗提示跳转购物车
      return Promise.reject(res)
    } else {
      // PC端首页未配置不提示
      if (!(res?.data?.code == EResponseCode.FAIL_202 && res?.data?.message == '首页未配置')) {
        showToast && res?.data?.message && message.info(res?.data?.message)
      }
      return Promise.reject(res)
    }
  },
  error => {
    console.log('---error', error.message)
    if (error?.config?.showLoading) {
      hideLoadDom()
    }
    return Promise.reject(error)
  }
)

export default class Http {
  /**
   * 发起请求
   * @param {string} url 请求 url
   * @param {any} params 请求参数
   * @param {boolean} showLoading 是否展示 loading 备用
   * @param {boolean} showToast 是否展示 toast 备用
   * @param {boolean} isFormData 是否form-data
   * @returns {Promise} 请求结果的Promise对象
   */
  static async request({ showLoading = false, showToast = true, isFormData = false, ...rest }) {
    //两个窗口切换，返回点击任何页面时，通过公共接口判断url的state是否与缓存一致，不一致刷新页面，更换state
    // isReloadPage()
    return await axios({ showLoading, showToast, isFormData, ...rest })
  }

  /**
   * 发起GET请求 get 请求参数用 params， post才用 data
   * @param {Object} req 请求参数
   * @param {string} req.url 请求 url
   * @param {any} req.data 请求参数
   * @param {boolean} req.showLoading 是否展示 loading
   * @param {boolean} req.showToast 是否展示 toast
   * @param {boolean} req.isFormData 是否form-data
   * @returns {Promise} 请求结果的Promise对象
   */
  static get({ data, ...rest }) {
    return this.request({
      method: 'GET',
      params: data,
      ...rest,
    })
  }

  /**
   * 发起PUT请求
   * @param {Object} req 请求参数
   * @param {string} req.url 请求 url
   * @param {any} req.data 请求参数
   * @param {boolean} req.showLoading 是否展示 loading
   * @param {boolean} req.showToast 是否展示 toast
   * @param {boolean} req.isFormData 是否form-data
   * @returns {Promise} 请求结果的Promise对象
   */
  static put(params = {}) {
    return this.request({
      method: 'PUT',
      ...params,
    })
  }

  /**
   * 发起POST请求
   * @param {Object} req 请求参数
   * @param {string} req.url 请求 url
   * @param {any} req.data 请求参数
   * @param {boolean} req.showLoading 是否展示 loading
   * @param {boolean} req.showToast 是否展示 toast
   * @param {boolean} req.isFormData 是否form-data
   * @returns {Promise} 请求结果的Promise对象
   */
  static post(params = {}) {
    return this.request({
      method: 'post',
      ...params,
    })
  }

  /**
   * 发起DELETE请求
   * @param {Object} req 请求参数
   * @param {string} req.url 请求 url
   * @param {any} req.data 请求参数
   * @param {boolean} req.showLoading 是否展示 loading
   * @param {boolean} req.showToast 是否展示 toast
   * @param {boolean} req.isFormData 是否form-data
   * @returns {Promise} 请求结果的Promise对象
   */
  static delete({ data, ...rest }) {
    return this.request({
      method: 'DELETE',
      params: data,
      ...rest,
    })
  }
}
